import Styles from "./index.module.scss";
import { ReactComponent as GoogleIcon } from "../../../../assets/icons/Google.svg";
import { ReactComponent as FacebookIcon } from "../../../../assets/icons/Facebook.svg";
import { ReactComponent as AppleIcon } from "../../../../assets/icons/Apple.svg";
import Button from "../button";
import { useAuthFrontLock } from '../../../../context/useAuthFrontContext';
import { ConnectionNamesEnum } from '@cimpress-technology/authfront-lock-sdk'
import { ERROR_CODE } from "../../../../utils/constant/constant";

const SocialLoginButtons = ({showErrorMessage}) => {

    const authFrontLock = useAuthFrontLock();

    const handleSocialButton = (event, mode) => {
        try {
            event.preventDefault()
            authFrontLock.authorizeSocial({ provider : mode })
          } catch (err : any) {
            if(err.errorCode === ERROR_CODE.REAUTHENTICATION_REQUIRED ){
                showErrorMessage(ERROR_CODE.REAUTHENTICATION_REQUIRED);
            } else {
                showErrorMessage(ERROR_CODE.SOCIAL_SIGNIN_ERROR);
            }
          }
    }

    return (
        <div className={Styles.container}>
            <Button id="google-sign-in" onClick={(event) => handleSocialButton(event,ConnectionNamesEnum.GOOGLE)} subClass="btn--pill" className={Styles.button}>
                <div className={Styles.logo}>
                    <GoogleIcon className={Styles.logoSize} />
                    <span>Google</span>
                </div>
            </Button>
            <Button id="facebook-sign-in" onClick={(event) => handleSocialButton(event, ConnectionNamesEnum.FACEBOOK)} subClass="btn--pill" className={Styles.button}>
                <div className={Styles.logo}>
                    <FacebookIcon className={Styles.logoSize} />
                    <span>Facebook</span>
                </div>
            </Button>
            <Button id="apple-sign-in" onClick={(event) => handleSocialButton(event, ConnectionNamesEnum.APPLE)} subClass="btn--pill" className={Styles.button}>
                <div className={Styles.logo}>
                    <AppleIcon className={Styles.logoSize} />
                    <span>Apple</span>
                </div>
            </Button>
        </div>
    )
}

export default SocialLoginButtons;